
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { LimitedUserType, UserLimitValidationResult } from "src/types/user";

export const useLicenseValidation = () => {
	const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

	const displayLicenseValidationMessages = (
		validationResults: UserLimitValidationResult[]
	) => {
		if (validationResults.length > 0) {
			validationResults.forEach((result) => {
				enqueueSnackbar(
					t("License.ValidationMessagePerType", {
						type: t(`License.${LimitedUserType[result.limitedUserType]}`),
						allowed: result.allowedNumberOfUsers,
						attempted: result.attemptedNumberOfUsers,
					}),
					{ variant: "error" }
				);
			});
		}
	};

	return { displayLicenseValidationMessages };
};